export const nriWhatsappUrl = "https://wa.me/919289791199?text=AUDIT";
export const nriStripeUrl = "https://buy.stripe.com/9B614mcE85NtgoB6bYgEg0k";
export const nriBookingUrl = "https://zbooking.in/KxVMm";
export const nriRahulPhoto = "https://customer-assets.emergentagent.com/job_cross-border-wealth/artifacts/pmgzag2g_rahul%20pic.png";
export const nriHeroBg = "https://images.pexels.com/photos/29470839/pexels-photo-29470839.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const nriHeroData = {
  eyebrow: "For Indian NRIs Living & Working Abroad",
  headlinePart1: "India Could Be Taxing Your",
  headlineAccent: "Foreign Income",
  headlinePart2: "Right Now.",
  headlineSub1: "And Your Tax Consultant",
  headlineSub2: "Probably Has No Idea.",
  subheadline: "Get your complete NRI Tax Position Report in 48 hours — find out exactly what you owe, what you've overpaid, and whether an IT notice is already building against your name.",
  socialProof: [
    { value: "1,000+", label: "NRI Returns Filed" },
    { value: "40+", label: "Countries" },
    { value: "₹4.2L", label: "Avg Tax Saved" },
    { value: "CA + SCA", label: "Licensed" },
  ],
  ctaText: 'WhatsApp Me "AUDIT" — Check My Tax Position',
  trustLine: "48-hour turnaround. 5 slots available this month.",
};

export const nriProblemData = {
  sectionLabel: "The Problem Nobody Is Telling You About",
  headline: "You Have a Tax Consultant Back in India.",
  headlineAccent: "But Do You Have the Right One?",
  bodyCopy: [
    "You've been filing your ITR every year.",
    "You have a tax consultant back home. They've been doing it for years. You trust them — and you should.",
    "Here's what they are almost certainly not doing — not because they're bad at their job, but because they've never had to file a return for someone living outside India:",
  ],
  mistakes: [
    {
      title: "Not claiming your DTAA benefit",
      body: "India has Double Tax Avoidance Agreements with 90+ countries — UK, UAE, USA, Canada, Singapore, Australia, and more. These treaties can protect your foreign income from Indian tax. But claiming them requires a Tax Residency Certificate (TRC) from your country of residence. Your India tax consultant has probably never asked you for one.",
    },
    {
      title: "Wrong residency classification",
      body: 'Filing you as a "Resident" when you\'re legally NRI or RNOR means your entire foreign salary becomes taxable in India. This single mistake can cost ₹5–35 lakh per year. It happens constantly when the tax consultant doesn\'t review your actual travel history.',
    },
    {
      title: "Missing Schedule FA Exposure Risk",
      body: "Schedule FA — the foreign asset disclosure schedule — is mandatory for Residents, not NRIs. But if India's Income Tax Department reclassifies you from NRI to Resident, every undisclosed overseas bank account, property, share, or investment becomes a ₹10 lakh annual penalty — retroactively. Most NRIs don't know this risk exists.",
    },
    {
      title: "Missing the RNOR window",
      body: "If you've lived abroad for 9 of the last 10 years, you qualify for RNOR (Resident but Not Ordinarily Resident) status when you eventually return — where ALL your foreign income is tax-free in India for 2–3 years. Most NRIs never use this window. It cannot be reclaimed once it passes.",
    },
    {
      title: "No prior-year review",
      body: "If any of these have been happening for 2–3 years, the overpaid tax and penalty risk has been compounding silently — and the window to claim a refund through a revised return is limited.",
    },
  ],
  costTable: [
    { mistake: "Wrong residency (Resident instead of NRI/RNOR)", costAmount: "₹5–35 lakh", costDesc: "/year on foreign salary" },
    { mistake: "DTAA never claimed", costAmount: "₹1–5 lakh", costDesc: "/year in excess TDS on dividends, rental income" },
    { mistake: "Schedule FA exposure (if reclassified as Resident)", costAmount: "₹10 lakh", costDesc: "/year per undisclosed foreign asset" },
    { mistake: "RNOR window missed entirely", costAmount: "₹10–30 lakh", costDesc: "in tax-free period lost forever" },
    { mistake: "IT notice + 12% compound interest", costAmount: "12%/year compound", costDesc: "Outstanding tax × interest + penalties" },
  ],
  callout: "The total hidden cost of inaction: ₹15–50 lakh over 3–5 years. Most NRIs are paying ₹3,000–5,000 for a filing — and unknowingly risking 100x that amount.",
};

export const nriInsightData = {
  sectionLabel: "Why This Keeps Happening",
  headline: "There Are 600,000+ Tax Consultants in India.",
  headlineAccent: "Almost None Have Filed a Return for Someone Living Abroad.",
  bodyCopy: [
    "NRI tax is not just Indian tax law.",
    "It sits at the intersection of Indian income tax, your country of residence's tax rules, the relevant DTAA treaty, FEMA regulations, RBI circulars on NRE/NRO accounts, and — for those returning — the RNOR transition window.",
    "A tax consultant filing from India sees only one half of this equation.",
    "To advise on cross-border NRI tax correctly, you need to understand both sides — the India tax system from the inside, AND what an NRI's life, income, and assets actually look like from outside India. That is a specific expertise. It is not what you get from a hometown tax consultant filing your return for ₹4,000.",
  ],
  comparisonRows: [
    { criterion: "Tax consultant qualification", them: "✅", us: "✅", themNeutral: true },
    { criterion: "Cross-border NRI specialisation", them: "❌", us: "✅ (10+ years, 1,000+ returns)" },
    { criterion: "UAE SCA License", them: "❌", us: "✅" },
    { criterion: "DTAA claim with TRC + Form 10F", them: "Often skipped", us: "Filed every year, for every client" },
    { criterion: "RNOR window identification", them: "Rarely", us: "Standard in every review" },
    { criterion: "Schedule FA (all foreign assets)", them: "Often incomplete", us: "Always complete" },
    { criterion: "Prior-year exposure review", them: "Not offered", us: "Included by default" },
    { criterion: "Post-filing support", them: "Usually unavailable", us: "30-day WhatsApp access" },
    { criterion: "Clients served across countries", them: "India only", us: "UAE, UK, US, Canada, Singapore, Australia, Gulf, Europe" },
  ],
  pullQuote: '"There are 600,000+ tax consultants in India. I\'m not competing with them. I\'m doing what they can\'t — from the other side of the border."',
};

export const nriOfferData = {
  sectionLabel: "The Solution",
  headline: "Introducing:",
  headlineAccent: "The NRI Tax Position Report",
  summary: [
    "This is not a standard ITR filing.",
    "This is a complete diagnostic of your current NRI tax position — followed by a correctly filed, fully protected return.",
    "In 48 hours, you will know:",
  ],
  bullets: [
    "Your exact residency classification — NRI, RNOR, or Resident — with the legal basis documented in writing",
    "Whether your DTAA benefit has been missed and the estimated refund value from prior years",
    "Whether Schedule FA applies to your situation — and if so, whether your foreign assets are fully disclosed or carry a ₹10 lakh+ exposure risk",
    "Whether a prior-year revised return is worth filing and what it would recover",
    "Then I file your ITR — correctly, completely, with every exemption and treaty claim you're legally entitled to.",
  ],
  outcomeStatement: "You are not buying an ITR filing. You are buying certainty that India cannot come after you.",
};

export const nriValueStackData = {
  sectionLabel: "Everything You Get",
  headline: "Here's What's Inside the",
  headlineAccent: "NRI Tax Position Report",
  deliverables: [
    {
      icon: "FileText",
      title: "Full Residency Status Determination",
      body: "I go through your 5-year travel history and income profile. You get a written document stating your exact legal classification — NRI, RNOR, or Resident — with the specific section of the Income Tax Act that applies.",
      whyItMatters: "Wrong classification = up to ₹35 lakh/year in unnecessary tax on your foreign income.",
      value: "₹8,000",
    },
    {
      icon: "Scale",
      title: "DTAA Analysis + Claim Filing",
      body: "I identify every income stream protected under the relevant tax treaty between India and your country of residence — salary, rental, dividends, capital gains. I guide TRC acquisition and file Form 10F and the DTAA claim with your ITR.",
      whyItMatters: "Without a correctly filed DTAA claim, you pay full Indian tax on income the treaty explicitly exempts.",
      value: "₹10,000",
    },
    {
      icon: "FileCheck",
      title: "ITR Filed in Correct Form",
      body: "ITR-2 or ITR-3 depending on your income profile — filed with the correct residency status, DTAA claim, and all schedules complete and accurate.",
      whyItMatters: "Wrong ITR form or incomplete schedules trigger automatic scrutiny notices.",
      value: "₹8,000",
    },
    {
      icon: "Globe",
      title: "Schedule FA Risk Assessment + Schedule FSI",
      body: "I determine whether Schedule FA (foreign asset disclosure) applies to your specific residency classification. I ensure every overseas bank account, property, share, or investment is disclosed correctly — avoiding a ₹10 lakh per year penalty. Schedule FSI is filed accurately for every overseas income stream.",
      whyItMatters: "If India reclassifies your residency, undisclosed foreign assets carry a mandatory ₹10 lakh per year penalty. No exceptions.",
      value: "₹6,000",
    },
    {
      icon: "Phone",
      title: "30-Minute Post-Filing Advisory Call",
      body: "Once your ITR is filed, we walk through every line together. You understand exactly what was filed, why, and what you need to do next year to stay compliant and protected.",
      whyItMatters: "Most people file and hope. You'll file and know.",
      value: "₹5,000",
    },
  ],
  totalValue: "₹37,000",
};

export const nriBonusData = {
  sectionLabel: "Included at No Extra Charge",
  headline: "5 Bonuses That Make This",
  headlineAccent: "a No-Brainer",
  bonuses: [
    {
      number: "01",
      title: "TRC Acquisition Guide (Country-Specific)",
      value: "₹5,000",
      body: "A step-by-step guide to obtaining your Tax Residency Certificate from your country of residence — UAE, UK, Singapore, Canada, Australia, or other. This is the mandatory document India now requires for every DTAA claim from AY 2026–27 onwards. Without it, your exemption is denied at assessment even if the rest of your filing is correct.",
    },
    {
      number: "02",
      title: "India DTAA Framework — Your Country's Treaty Explained",
      value: "₹8,000",
      body: "The complete article-by-article breakdown of what income is protected, what's not, and what India can and cannot tax you on — specific to the treaty between India and your country of residence. Used by 3,000+ NRIs across 40+ countries.",
    },
    {
      number: "03",
      title: "NRE / NRO Account Structure Review",
      value: "₹6,000",
      body: "I review how your India income streams are structured across NRE and NRO accounts and flag any errors. NRE interest = 100% tax-free. NRO interest = 30% TDS deducted automatically. Most NRIs have at least one account structured incorrectly — the cost is ₹50,000–2 lakh/year in unnecessary tax.",
    },
    {
      number: "04",
      title: "Prior-Year ITR Exposure Check",
      value: "₹10,000",
      body: "I scan your last 2 years of filed ITRs for mis-classifications, missed DTAA claims, or Schedule FA gaps. If there's a refund opportunity — I identify it, quantify it in rupees, and tell you exactly what to do. This single check has recovered ₹2–8 lakh for NRIs who had no idea there was money sitting unclaimed.",
    },
    {
      number: "05",
      title: "30-Day WhatsApp Support",
      value: "₹8,000",
      body: "Direct WhatsApp access for 30 days after your ITR is filed. Any IT notice, any bank query about your NRI status, any document request — I respond personally. Not a team. Not an assistant. Me.",
    },
  ],
  valueSummary: [
    { label: "Core Work Value", amount: "₹37,000" },
    { label: "Bonus 1 — TRC Guide", amount: "₹5,000" },
    { label: "Bonus 2 — DTAA Framework", amount: "₹8,000" },
    { label: "Bonus 3 — NRE/NRO Review", amount: "₹6,000" },
    { label: "Bonus 4 — Prior-Year Check", amount: "₹10,000" },
    { label: "Bonus 5 — WA Support", amount: "₹8,000" },
  ],
  totalValue: "₹74,000",
  yourInvestment: "$160",
  yourInvestmentAlt: "599 AED",
};

export const nriGuaranteeData = {
  sectionLabel: "You Risk Nothing",
  headline: "The Zero Discovery",
  headlineAccent: "Guarantee",
  guaranteeText: [
    "I will audit your last 2 years of ITR filings before you commit to anything.",
    "If I find zero issues — correct residency, DTAA filed properly with TRC, Schedule FA position clean — I charge you nothing for the audit. You pay only for the current year's ITR filing.",
    "If your ITR is queried or rejected by the Income Tax Department on any point that falls within my scope of work, I handle the entire response at zero additional cost. No hourly fees. No revision charges.",
    "You are not risking your money.",
  ],
  calloutLine1: "The risk of acting: 30 minutes on a call.",
  calloutLine2: "The risk of not acting: ₹15–50 lakh over the next 3–5 years.",
};

export const nriAuthorityData = {
  sectionLabel: "Who I Am",
  headline: "CA Rahul Taneja",
  headlineAccent: "NRI Tax Specialist. Based in Dubai. Serving NRIs Across 40+ Countries.",
  photo: "https://customer-assets.emergentagent.com/job_cross-border-wealth/artifacts/pmgzag2g_rahul%20pic.png",
  bioParagraphs: [
    "I am a Chartered Accountant with a UAE SCA Financial Influencer License.",
    "I have been filing cross-border NRI tax returns for 10+ years — from inside Dubai, for clients living and working in UAE, UK, US, Canada, Singapore, Australia, and beyond.",
    "I have filed over 1,000+ NRI returns for clients in more than 40 countries.",
    "I am not a remote filing service. I am not a form-filler. I am a cross-border tax strategist who has spent 10+ years at the intersection of Indian tax law and the financial reality of Indians living abroad.",
    "My clients include salaried NRIs, business owners, HNIs with property in India, returning NRIs navigating the RNOR window, and NRIs with complex capital gains, inheritance, and multi-country investment situations.",
  ],
  credentials: [
    "CA — ICAI",
    "UAE SCA Licensed",
    "10+ Years Cross-Border Practice",
    "1,000+ NRI Returns",
    "40+ Countries Served",
  ],
  caseStudy: {
    location: "Real Result — Dubai, UAE",
    client: "Ravi. 42 years old. Software engineer. Foreign salary: ₹1.2 crore.",
    story: "India-based tax consultant had been filing him as a Resident for years. He was legally RNOR. We filed a revised ITR with correct RNOR classification + Tax Residency Certificate.",
    result: "Tax liability: ₹36 lakh → ₹2.1 lakh",
    savings: "₹33.9 lakh saved. 100% legal. Zero scrutiny. Accepted on first submission.",
    note: "His India tax consultant wasn't wrong. They just didn't know what living outside India changes.",
  },
  socialProof: "@ca_rahul_dxb — followed by 24,000+ NRIs across the world for cross-border tax clarity",
  instagram: "https://www.instagram.com/ca_rahul_dxb",
  youtube: "https://www.youtube.com/@Rahul_kumar_dxb",
};

export const nriUrgencyData = {
  sectionLabel: "Why This Can't Wait",
  headline: "3 Active Deadlines Working Against",
  headlineAccent: "Every NRI Right Now",
  deadlines: [
    {
      number: "01",
      label: "DEADLINE 1",
      title: "New Indian Tax Law — Effective April 1, 2026",
      body: "The Income Tax Bill 2025 is now in effect. The 120-day residency rule applies from this financial year: if you're an Indian citizen, visited India for 120+ days in FY2025–26, AND have Indian income above ₹15 lakh — your residency classification may have changed, regardless of which country you live in. This affects the ITR you file in July 2026. The earlier you know your status, the more options you have.",
    },
    {
      number: "02",
      label: "DEADLINE 2",
      title: "TRC Is Now Mandatory for DTAA — ITR Deadline July 31",
      body: "India has formalised the requirement: from AY 2026–27, a Tax Residency Certificate (TRC) from your country of residence is mandatory to allow your DTAA benefit. Without it, your exemption is denied at assessment — even if you've been claiming DTAA for years. TRC applications take 3–14 days depending on your country. Starting in June is already cutting it close.",
    },
    {
      number: "03",
      label: "DEADLINE 3",
      title: "Revised Return Window — Closing Soon",
      body: "The window to file a revised or belated return for FY2022–23 is closing. If you've been over-classified as a Resident, or your DTAA claim was never filed, or your Schedule FA was incomplete — this may be the last year to recover the excess tax or resolve the compliance gap. Once this window closes, that refund and that correction are gone permanently.",
    },
  ],
  scarcity: "I take 5 clients per month for this engagement. Not a manufactured number. Each case gets my direct, personal attention — I don't delegate cross-border NRI analysis.",
};

export const nriFinalCtaData = {
  headline: "Find Out Exactly Where You Stand",
  headlineAccent: "— In 48 Hours",
  steps: [
    { step: "1", text: "You send a WhatsApp message with the word AUDIT" },
    { step: "2", text: "I reply within 2 hours with 2 quick qualifying questions" },
    { step: "3", text: "If you're the right fit, we do a 30-minute call — I'll ask about your residency history, income profile, and filing situation" },
    { step: "4", text: "Within 48 hours, you receive a written NRI Tax Position summary — residency status, DTAA position, Schedule FA gaps, and any prior-year refund opportunity identified in rupees" },
    { step: "5", text: "If you want to engage for the full filing, we proceed. If not — the assessment is yours. No charge, no obligation, no follow-up sales pressure." },
  ],
  primaryCta: 'WhatsApp Me "AUDIT" — Free NRI Tax Assessment',
  secondaryCta: "Book a 15-Minute Call Directly",
};

export const nriFaqData = {
  sectionLabel: "Common Questions",
  headline: "Everything You're",
  headlineAccent: "Wondering",
  faqs: [
    {
      question: "I already have a tax consultant in India. Why do I need you?",
      answer: "You should keep your India tax consultant — they're excellent for Indian compliance work. What I handle is a completely different scope.\n\nYour India tax consultant covers Indian-side tax law. I cover the cross-border piece: the DTAA treaty specific to your country of residence, TRC acquisition, RNOR window identification, Schedule FA for your foreign assets, and FEMA compliance.\n\nMost of my clients have their India tax consultant and me working in parallel. I don't touch the Indian compliance work your tax consultant already handles. I handle everything they can't do from India.",
    },
    {
      question: "I live in the UK / US / Singapore / Canada — is this relevant to me?",
      answer: "Yes. This service is for all Indian NRIs, regardless of which country you live in.\n\nIndia has DTAA treaties with 90+ countries — UK, USA, Canada, Singapore, Australia, UAE, Germany, Netherlands, and more. The core mistakes — wrong residency classification, missed DTAA claims, incomplete Schedule FA — happen to NRIs everywhere.\n\nThe TRC you need comes from your country of residence. The DTAA treaty that applies is the one between India and your country. I work through all of these, wherever you're based.",
    },
    {
      question: "Is this really necessary? I've been filing for years without a notice.",
      answer: '"No notice yet" is not the same as "no problem."\n\nIT assessments typically happen 1–3 years after filing, not immediately. Many NRIs are receiving notices right now for returns filed in FY2021–22 and FY2022–23.\n\nThe fact that you haven\'t received a notice doesn\'t confirm your filing is correct. It means the scrutiny hasn\'t reached your file yet.\n\nIf everything is genuinely in order — the 48-hour assessment will confirm that, and you get peace of mind at zero cost.',
    },
    {
      question: "What if I'm already filing with DTAA?",
      answer: 'Ask your tax consultant one specific question: "Have you been attaching my Tax Residency Certificate (TRC) from [country] AND filing Form 10F with every ITR?"\n\nIf they pause, or say TRC wasn\'t required, or say they claim DTAA without TRC — that is a material issue. From AY 2026–27 onwards, TRC and Form 10F are mandatory. Without them, the DTAA claim is denied at assessment even if the rest of the filing looks correct.',
    },
    {
      question: "How do I know if my residency status is wrong?",
      answer: "Honestly — you probably don't. And neither does your India tax consultant unless they have gone through your passport entry/exit history for every year and cross-referenced it against the legal definition of NRI and RNOR.\n\nMost India tax consultants ask \"are you an NRI?\" You say yes. They file accordingly. Nobody independently verifies the travel history.\n\nThat verification is the first thing I do. It takes 10 minutes, uses your passport data, and is the most consequential 10 minutes in any NRI tax review.",
    },
    {
      question: "How long does the full engagement take?",
      answer: "Assessment findings: Delivered in writing within 48 hours of your first call\n\nDocument collection: You send 4–6 documents via WhatsApp\n\nITR filing: Completed within 7 working days of receiving documents\n\nYour total active involvement: Approximately 1 hour across the entire engagement\n\nI handle everything. You provide the documents, I do the analysis and filing. You review and approve before submission.",
    },
    {
      question: "What documents do I need?",
      answer: "Passport (for travel history verification)\n\nResidency visa / permit copy from your country of residence\n\nTRC from your country of residence (or I'll guide you on how to get it)\n\nForm 26AS from the Indian IT portal\n\nNRE + NRO bank statements\n\nLast 2 years of filed ITRs (if available)\n\nI'll send you a complete, country-specific checklist via WhatsApp after the assessment call.",
    },
    {
      question: "What if I'm not sure I qualify?",
      answer: "Send me the word AUDIT on WhatsApp and add one line about your situation. I'll respond within 2 hours and tell you directly whether this is the right fit.\n\nIf you don't qualify — I'll tell you that and point you toward the right solution. I'd rather lose a ₹14,999 engagement than have you pay for something you don't need.",
    },
  ],
};

export const nriPageFooterData = {
  socialProofLine: "Trusted by 1,000+ NRIs across UAE, UK, USA, Canada, Singapore, Australia, and 40+ other countries.",
  name: "CA Rahul Taneja",
  credentials: "CA (ICAI) + SCA Licensed (UAE)",
  location: "Dubai, UAE — serving NRIs globally",
  website: "carahultaneja.com",
  handle: "@ca_rahul_dxb",
  whatsapp: "+91 92897 91199",
  instagram: "https://www.instagram.com/ca_rahul_dxb",
  youtube: "https://www.youtube.com/@Rahul_kumar_dxb",
  linkedin: "https://www.linkedin.com/in/rahulkumardxb/",
  disclaimer: "This page is for informational purposes. Tax outcomes vary based on individual circumstances. Engaging CA Rahul Taneja constitutes a client relationship governed by the terms of service shared at onboarding. All advice covers India cross-border taxation and is specific to each client's country of residence and income profile.",
};
